import { IResponse } from "features/common/hooks/useRequest";
import axios from "axios";
import { DropdownDto } from "features/common/models/DropdownDto";

export async function fetchTexByProjeto(projetoId: string): Promise<IResponse<DropdownDto[]>> {
  return await axios.get(`/Tex/${projetoId}`);
}